import { useStore } from 'store/store';
import { useUtxWalletGetWalletByAsset } from '../../../../../packages/utx-client/src/react';

interface UseWalletsParams {
  enabled?: boolean;
  noSave?: boolean;
  search?: string;
}

export const useWallets = (params: UseWalletsParams) => {
  const { enabled = false } = params;
  const store = useStore();
  const normalizedSearch = params.search?.trim() || undefined;

  const wallets = useUtxWalletGetWalletByAsset({
    axios: normalizedSearch
      ? {
          params: {
            search: normalizedSearch
          }
        }
      : undefined,
    query: {
      enabled,
      queryKey: ['/wallets-by-asset', normalizedSearch ?? ''],
      onSuccess: (data) => {
        if (params.noSave) return;
        store.changeWallets(data.data);
      }
    }
  });

  return {
    wallets
  };
};
